import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import { markPWAPrompted, saveSettings } from '../store/slices/uiSlice';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/PWAInstallPrompt.css';

interface PWAInstallPromptProps {
  onClose: () => void;
}

const PWAInstallPrompt: React.FC<PWAInstallPromptProps> = ({ onClose }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    } else {
      if (isIOS()) {
        alert(t('pwa.iosInstruction'));
      } else {
        alert(t('pwa.manualInstruction'));
      }
    }
    
    // IndexedDB (Redux) に記録
    dispatch(markPWAPrompted());
    dispatch(saveSettings({ hasPromptedPWA: true }));
    onClose();
  };

  const handleDismiss = () => {
    dispatch(markPWAPrompted());
    dispatch(saveSettings({ hasPromptedPWA: true }));
    onClose();
  };

  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

  const getInstallButtonText = () => {
    if (isIOS()) return t('pwa.installIOS');
    if (deferredPrompt) return t('pwa.installAndroid');
    return t('pwa.learnMore');
  };

  return (
    <div className="pwa-install-prompt-overlay">
      <div className="pwa-install-prompt">
        <div className="pwa-install-header">
          <img src="/icon-512x512.png" alt="hibi" className="pwa-install-icon" />
          <div className="pwa-install-title">
            <h3>{t('pwa.title')}</h3>
            <p>{t('pwa.subtitle')}</p>
          </div>
        </div>
        
        <div className="pwa-install-benefits">
          <div className="benefit-item"><span>📱</span><span>{t('pwa.benefit1')}</span></div>
          <div className="benefit-item"><span>⚡</span><span>{t('pwa.benefit2')}</span></div>
          <div className="benefit-item"><span>📴</span><span>{t('pwa.benefit3')}</span></div>
        </div>

        <div className="pwa-install-actions">
          <button className="pwa-install-btn primary" onClick={handleInstall}>{getInstallButtonText()}</button>
          <button className="pwa-install-btn secondary" onClick={handleDismiss}>{t('pwa.notNow')}</button>
        </div>
        
        <button className="pwa-install-close" onClick={handleDismiss}>×</button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
